(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function getCartUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart) {
      return window.theme.routes.cart;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }

    return '/cart.js';
  }

  function getBottleWord(count) {
    return count === 1 ? 'Flasche' : 'Flaschen';
  }

  function getShippingRelevantWeight(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (item.gift_card === true) return total;
      if (item.requires_shipping === false) return total;

      const itemWeight = Number(item.grams || 0);
      const itemQuantity = Number(item.quantity || 0);

      return total + itemWeight * itemQuantity;
    }, 0);
  }

  function updateCartSummary(summary, cart) {
    const freeShippingWeight = Number(summary.dataset.freeShippingWeight || 24000);
    const standardShippingPrice = Number(summary.dataset.standardShippingPrice || 590);

    const shippingRelevantWeight = getShippingRelevantWeight(cart);
    const hasShippingRelevantItems = shippingRelevantWeight > 0;

    const shippingPrice =
      !hasShippingRelevantItems || shippingRelevantWeight >= freeShippingWeight
        ? 0
        : standardShippingPrice;

    const totalIncludingShipping = cart.total_price + shippingPrice;

    const subtotalElement = summary.querySelector('[data-christ-cart-subtotal]');
    const shippingElement = summary.querySelector('[data-christ-cart-shipping]');
    const totalElement = summary.querySelector('[data-christ-cart-total]');

    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(cart.total_price);
    }

    if (shippingElement) {
      shippingElement.textContent = shippingPrice === 0 ? 'Gratis' : formatMoney(shippingPrice);
    }

    if (totalElement) {
      totalElement.textContent = formatMoney(totalIncludingShipping);
    }
  }

  function updateShippingProgress(progressElement, cart) {
    const targetBottles = Number(progressElement.dataset.targetBottles || 24);
    const targetWeight = Number(progressElement.dataset.targetWeight || 24000);
    const gramsPerBottle = Number(progressElement.dataset.gramsPerBottle || 1000);

    const currentWeight = getShippingRelevantWeight(cart);

    if (currentWeight <= 0) {
      progressElement.style.display = 'none';
      return;
    }

    progressElement.style.display = '';

    const currentBottles = Math.floor(currentWeight / gramsPerBottle);
    const missingBottles = Math.max(0, Math.ceil((targetWeight - currentWeight) / gramsPerBottle));
    const progress = Math.min(100, Math.round((currentWeight / targetWeight) * 100));

    const copy = progressElement.querySelector('.wine-shipping-progress__copy');
    const fill = progressElement.querySelector('.wine-shipping-progress__fill');
    const track = progressElement.querySelector('.wine-shipping-progress__track');

    if (copy) {
      if (currentWeight >= targetWeight) {
        copy.innerHTML = `
          <p class="wine-shipping-progress__headline">Dein Versand ist Gratis</p>
          <p class="wine-shipping-progress__subline">${targetBottles} Flaschen erreicht. Der Versand geht auf uns.</p>
        `;
      } else {
        copy.innerHTML = `
          <p class="wine-shipping-progress__headline">Nur noch ${missingBottles} ${getBottleWord(missingBottles)} bis zum Gratisversand</p>
          <p class="wine-shipping-progress__subline">${currentBottles} von ${targetBottles} Flaschen erreicht.</p>
        `;
      }
    }

    if (fill) {
      fill.style.width = progress + '%';
    }

    if (track) {
      track.setAttribute('aria-valuenow', String(progress));
    }
  }

  async function refreshChristCart() {
    const summaries = document.querySelectorAll('[data-christ-cart-summary]');
    const progressElements = document.querySelectorAll('[data-wine-shipping-progress]');

    if (!summaries.length && !progressElements.length) return;

    try {
      const response = await fetch(getCartUrl(), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      summaries.forEach(function (summary) {
        updateCartSummary(summary, cart);
      });

      progressElements.forEach(function (progressElement) {
        updateShippingProgress(progressElement, cart);
      });
    } catch (error) {
      console.warn('Christ cart update failed.', error);
    }
  }

  document.addEventListener('DOMContentLoaded', refreshChristCart);
  document.addEventListener('cart:updated', refreshChristCart);
  document.addEventListener('cart:change', refreshChristCart);
  document.addEventListener('ajaxCart:updated', refreshChristCart);
  document.addEventListener('ajaxProduct:added', refreshChristCart);
  document.addEventListener('drawerOpen.CartDrawer', refreshChristCart);

  document.addEventListener('click', function (event) {
    const target = event.target;

    if (
      target.closest('button[name="add"]') ||
      target.closest('button[name="plus"]') ||
      target.closest('button[name="minus"]') ||
      target.closest('[data-cart-remove]') ||
      target.closest('[data-add-to-cart]') ||
      target.closest('.js-qty__adjust') ||
      target.closest('.quantity__button') ||
      target.closest('.cart__remove') ||
      target.closest('cart-remove-button')
    ) {
      window.setTimeout(refreshChristCart, 400);
      window.setTimeout(refreshChristCart, 900);
    }
  });

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (
      target.matches('input[name="updates[]"]') ||
      target.matches('.quantity__input') ||
      target.matches('.js-qty__num')
    ) {
      window.setTimeout(refreshChristCart, 400);
      window.setTimeout(refreshChristCart, 900);
    }
  });
})();